import React from 'react';
import { MonitorUp } from 'lucide-react';

/* The one habit this whole feature rests on.
 *
 * Blurring protects the fields whatever somebody shares. The window that lets them read their
 * own details back only stays out of the call if they shared a TAB or a WINDOW — pick "Entire
 * Screen" and it is on the call in plain text, which is worse than never having had it.
 *
 * ProTrack is never told when the share dialog opens, so this cannot appear at the moment the
 * choice is made. It sits on the pages where these details get typed instead: not dismissible,
 * because a notice that can be clicked away is clicked away on the first call and never seen
 * again, and small enough that it is furniture rather than an alarm. */
export default function ShareTabNote({ className = '' }) {
    return (
        <div className={`flex items-start gap-2.5 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2.5 text-[12px] leading-relaxed text-amber-900 ${className}`}>
            <MonitorUp className="w-4 h-4 shrink-0 mt-0.5 text-amber-600" />
            <p>
                <span className="font-semibold">Sharing your screen? Share this tab, not your whole screen.</span>{' '}
                Your details stay blurred either way. But the window that shows them back to you is only
                hidden from the people watching when you have shared a single tab or window.
            </p>
        </div>
    );
}
